import { render, staticRenderFns } from "./ProductFilter.vue?vue&type=template&id=3c1847d8"
import script from "./ProductFilter.vue?vue&type=script&lang=js"
export * from "./ProductFilter.vue?vue&type=script&lang=js"
import style0 from "./ProductFilter.vue?vue&type=style&index=0&id=3c1847d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports